import React, { Component } from 'react';
import ChatBotApiService from "../../../services/chatbot-api.service";
import GlobalStoreService from "../../../services/global-store.service";
import ConfirmationBox from "../../common-components/confirmation-box.component";
import BotType from "../../../enums/BotType";
import IdleTimeoutService from "../../../services/idle-timeout.service";
import PlatformType from '../../../enums/PlatformType';
import UtilService from "../../../services/util.service";
import Swipe from 'react-easy-swipe';
import globalStoreService from '../../../services/global-store.service';



class ChatBarOptions extends Component {

    constructor(props) {
        super(props)
        this.state = {
            bar_inner_options_visible: true,
            active_option: undefined,
            showNumbersToSwitchBot: this.props.showNumbersToSwitchBot

        }
    }

    insertAccountTypeInfo = (accounts, type) => {
        accounts.forEach(element => {
            element["type"] = type;
        });
    }

    componentDidMount() {
        IdleTimeoutService.updateIdleState();
        let bot_type = GlobalStoreService.get('currentBotType');
        let userProfile = GlobalStoreService.get('userProfile');

        let optionsCategories = {}
        if (userProfile && GlobalStoreService.get('isUserLoggedIn')) {

            // let numbers_to_show = UtilService.getUserProfileNumbersWithAccountType()
            const numbers_to_show = GlobalStoreService.get("userAccounts")
            numbers_to_show.map((number, index) => {
                number['category_order'] = 0
            })

            if (numbers_to_show.length > 1) {
                optionsCategories['switch a/c'] = numbers_to_show
            }
        }

        if (!GlobalStoreService.get('categoriesFetched')[BotType[GlobalStoreService.get('currentBotType')]]) {
            ChatBotApiService.getOptionsCategories().then(
                res => {
                    GlobalStoreService.set("categoriesFetched", { ...GlobalStoreService.get('categoriesFetched'), [BotType[GlobalStoreService.get('currentBotType')]]: res })
                    let options = res
                    let sorted_options = Object.keys(options).sort(function (a, b) {
                        return options[a][0].category_order - options[b][0].category_order
                    })
                    let active_option = sorted_options[0]
                    if (sorted_options[0] === 'switch a/c' && !this.state.showNumbersToSwitchBot) {
                        active_option = sorted_options[1]
                    }
                    this.setState({ optionsCategories: { ...res, ...optionsCategories }, active_option: active_option })
                    let options2 = { ...res, ...optionsCategories };
                    let sorted_options2 = Object.keys(options2).sort(function (a, b) {
                        return options2[a][0].category_order - options2[b][0].category_order
                    })
                    // console.log('sorted options', sorted_options2)
                    this.setState({ sorted_options: sorted_options2 })
                    if (sorted_options2[0] === 'switch a/c' && this.state.showNumbersToSwitchBot) {
                        this.setState({ active_option: sorted_options2[0] })
                    }


                },
                err => {
                    // console.log(optionsCategories)
                    if (Object.keys(optionsCategories).length > 0) {
                        this.setState({ optionsCategories, active_option: Object.keys(optionsCategories)[0] ? Object.keys(optionsCategories)[0] : undefined })
                    }
                    else {
                        this.props.closeOptions()
                    }
                }
            )
        }
        else {
            let options = { ...optionsCategories, ...GlobalStoreService.get('categoriesFetched')[BotType[GlobalStoreService.get('currentBotType')]] }
            let sorted_options = Object.keys(options).sort(function (a, b) {
                return options[a][0].category_order - options[b][0].category_order
            })
            let active_option = sorted_options[0]
            if (sorted_options[0] === 'switch a/c' && !this.state.showNumbersToSwitchBot) {
                active_option = sorted_options[1]
            }

            this.setState({ optionsCategories: { ...options }, active_option: active_option, sorted_options })
        }

    }
    renderOptionsBar = () => {
        IdleTimeoutService.updateIdleState();
        let bot_type = GlobalStoreService.get('currentBotType')
        let options = this.state.optionsCategories;
        let sorted_options = Object.keys(options).sort(function (a, b) {
            return options[a][0].category_order - options[b][0].category_order
        })

        return (<ul>{sorted_options.map(option_key => {
            return (
                <li key={option_key} id={option_key}
                >
                    <a href="javascript:void(0)" className={(this.state.active_option === option_key) ? `active${GlobalStoreService.get('platformType') === PlatformType.WEB ? '-red' : ''}` : `${GlobalStoreService.get('platformType') === PlatformType.WEB ? 'red' : 'blue'}`}
                        onClick={() => {
                            IdleTimeoutService.updateIdleState();
                            this.setState({ bar_inner_options_visible: true, active_option: option_key })

                        }}>
                        <span className={`icon${GlobalStoreService.get('platformType') === PlatformType.WEB ? '-red' : ''} ${(option_key === 'switch a/c') ? 'switch-ac' : option_key.toLowerCase()}`} />
                        <span style={{ textTransform: 'uppercase' }}>{option_key}</span>
                    </a>
                </li>
            )
        })}
        </ul>)
    }

    getAccountType = (account) => {
        let accountType = BotType.getNumberTypeToShow(account.type)
        return accountType.charAt(0).toUpperCase() + accountType.slice(1)
    }

    renderSelectedOptionsScenarios = () => {
        IdleTimeoutService.updateIdleState();
        let option = this.state.active_option

        let option_scenarios = this.state.optionsCategories[option]
        if (option !== 'switch a/c') {
            option_scenarios.sort(function (a, b) {
                return a.scenario_order - b.scenario_order;
            });

            return (
                option_scenarios.slice(0, GlobalStoreService.get('currentBotType') === BotType.PAYMENTS_BANK ? 5 : 4).map((option, index) => {
                    return (
                        <li key={index} onClick={() => {
                            this.props.onCategoryOptionClick(option)
                            this.props.closeOptions()
                        }}><a href="javascript:void(0)">{option.scenario_description_en}</a></li>
                    )
                })
            )
        }
        else if (option === 'switch a/c') {
            return (
                option_scenarios.map((item, index) => {
                    if (item.siNumber !== GlobalStoreService.get('currentNumber')) {
                        return (
                            <li key={index} onClick={() => {

                                this.props.showPopup(<div>
                                    {/* <div className="switch-case">
                              <span className="pull-left"><img src="assets/images/switch-ac.png"  width="50"/></span>
                              <span className="fs-16 switch-heading">SWITCH ACCOUNT ?</span>
                          </div> */}
                                    <ConfirmationBox
                                        title={'Switch Account?'}
                                        messages={['This will end your current chat session and will start a new one with the account you have selected.']}
                                        buttons={[
                                            {
                                                label: 'CANCEL',
                                                onClick: () => {
                                                    IdleTimeoutService.updateIdleState();
                                                    this.props.closeOptions()
                                                    this.props.showPopup(undefined)
                                                }
                                            },
                                            {
                                                highlight: true,
                                                label: 'SWITCH',
                                                onClick: () => {
                                                    IdleTimeoutService.updateIdleState();
                                                    this.props.onSwitchNumber(item)
                                                    this.props.clearInputFieldAndSuggestions()
                                                    this.props.closeOptions()
                                                    this.props.showPopup(undefined)

                                                }
                                            },
                                        ]} /></div>)

                            }}>
                                <a href="javascript:void(0)">{item.customerName}-{item.siNumber} ({this.getAccountType(item)})</a>
                            </li>
                        )
                    }
                })
            )
        }

    }
    onSwipeMove = (position, event) => {
        this.swipeGesture = UtilService.returnSwipeGesture(position);
    }

    onSwipeLeft = () => {
        if (this.swipeGesture === 'HORIZONTAL_SWIPE') {
            let active_option = this.state.active_option;
            let active_index = this.state.sorted_options.findIndex(option => option === active_option)

            if (active_index < this.state.sorted_options.length - 1) {
                this.setState({ active_option: this.state.sorted_options[active_index + 1] })
                document.getElementById(`${this.state.sorted_options[active_index + 1]}`) && document.getElementById(`${this.state.sorted_options[active_index + 1]}`).scrollIntoView();
            }
        }
    }

    onSwipeRight = () => {
        if (this.swipeGesture === 'HORIZONTAL_SWIPE') {
            let active_option = this.state.active_option;
            let active_index = this.state.sorted_options.findIndex(option => option === active_option)

            if (active_index > 0) {
                this.setState({ active_option: this.state.sorted_options[active_index - 1] })
                document.getElementById(`${this.state.sorted_options[active_index - 1]}`) && document.getElementById(`${this.state.sorted_options[active_index - 1]}`).scrollIntoView();
            }
        }
    }

    getSnapshotBeforeUpdate(prevProps, prevState) {
        let new_active_index = this.state.sorted_options && this.state.sorted_options.findIndex(option => option === this.state.active_option)
        let prev_active_index = this.state.sorted_options && this.state.sorted_options.findIndex(option => option === prevState.active_option)

        if (document.getElementById('optionsScenarioList') && prevState.active_option !== this.state.active_option && new_active_index && prev_active_index) {

            if (new_active_index > prev_active_index) {
                document.getElementById('optionsScenarioList').classList.add('optionsAnimSwipeLeft')
                setTimeout(() => {
                    document.getElementById('optionsScenarioList') && document.getElementById('optionsScenarioList').classList.remove('optionsAnimSwipeLeft')
                }, 300)
            }
            else {
                document.getElementById('optionsScenarioList').classList.add('optionsAnimSwipeRight')
                setTimeout(() => {
                    document.getElementById('optionsScenarioList') && document.getElementById('optionsScenarioList').classList.remove('optionsAnimSwipeRight')
                }, 300)
            }

        }
        return true
    }
    componentDidUpdate() {

    }

    render() {
        return (

            <div className={"bottom-menu-expand" + " " + (globalStoreService.get("currentBotType") === BotType.PAYMENTS_BANK ? "paymentsbank" : "")} id='chat-bar-options' style={{ padding: '0 0' }}>
                {!this.state.optionsCategories && <p className="fs-regular fs-13 color-mid-grey pt-10 pb-10 ml-10">Fetching categories...</p>}
                {this.state.optionsCategories && <div className="btm-link">
                    <div className="links-scroll">{this.renderOptionsBar()}</div>
                </div>}
                {this.state.bar_inner_options_visible && this.state.active_option &&
                    <Swipe
                        onSwipeRight={this.onSwipeRight}
                        onSwipeLeft={this.onSwipeLeft}
                        onSwipeMove={this.onSwipeMove}>
                        <div id="optionsScenarioList" className={"options " + (UtilService.getOS() === "Windows" ? "custom-scrollbar" : "")} style={{ height: '195px' }}>
                            <ul>
                                {this.state.optionsCategories && this.renderSelectedOptionsScenarios()}
                            </ul>
                        </div>
                    </Swipe>
                }
            </div>


        );
    }
}

export default ChatBarOptions;



// WEBPACK FOOTER //
// ./src/components/bottom-components/default-chat-bar-components/chatBarOptionsComponent.js